require('../filter-editor-modal.component.scss');


export class GraphicObjectsFilterEditorController {

  constructor($scope, CurrentModelService) {
    this.$scope = $scope;
    this.CurrentModelService = CurrentModelService;
  }

  $onInit() {

    this.$scope.filter = this.filter.filter;

  }

}

export const GraphicObjectsFilterEditorComponent = {
  bindings: {
    filter    : '<',
  },
  template: require('./graphicobjects-filter-editor.component.html'),
  controller: GraphicObjectsFilterEditorController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/spec-forms/graphicobjects-filter-editor.component.js